import {
    Button,
    Column,
    Container,
    MaterialContext,
    Row,
    Text,
    ThemeContext,
} from '@wonderlandengine/react-ui/components';
import { Align, Justify, ReactUiBase } from '@wonderlandengine/react-ui';
import React, { useState, useEffect } from 'react';
import { GameFlowController } from '../core/game-flow-controller.js';

const TheEndComponent = (props: { comp: TheEnd }) => {
    const theme = {
        colors: {
            background: '#00000000',
            text: '#d3c8ad',
            primary: '#ffffff',
            secondary: '#ffffff',
            accent: '#ffffff',
        },
    };

    useEffect(() => {
        GameFlowController.instance.ready();
    }, []);

    return (
        <MaterialContext.Provider value={props.comp}>
            <ThemeContext.Provider value={theme}>
                <Container
                    left="-50%"
                    top="-50%"
                    alignItems={Align.Center}
                    justifyContent={Justify.Center}
                >
                    <Container
                        width={50}
                        padding={5}
                        alignItems={Align.Center}
                        justifyContent={Justify.Center}
                    >
                        <Column
                            alignItems={Align.Center}
                            alignContent={Align.Center}
                            justifyContent={Justify.Center}
                        >
                            <Row width={150} alignItems={Align.FlexEnd}>
                                <Text
                                    width={40}
                                    fontSize={50}
                                    text="The"
                                ></Text>
                            </Row>
                            <Row
                                marginTop={-15}
                                width={120}
                                alignItems={Align.FlexEnd}
                            >
                                <Text
                                    width={40}
                                    fontSize={50}
                                    text="End"
                                ></Text>
                            </Row>
                        </Column>
                    </Container>
                </Container>
            </ThemeContext.Provider>
        </MaterialContext.Provider>
    );
};

export class TheEnd extends ReactUiBase {
    static TypeName = 'ui:the-end';
    static InheritProperties = true;

    onActivate(): void {
        super.onActivate();
    }

    override async start(): Promise<void> {
        super.start();
    }

    override update(dt: number) {
        super.update(dt);
    }

    render() {
        return <TheEndComponent comp={this} />;
    }
}
